import { rankingItems } from '@/mocks/homepage';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-fire-line text-xl text-primary-500"></i>
              <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
                影视热播榜
              </h2>
            </div>
            <p className="text-sm text-foreground-500">实时更新 · 全网热度排行</p>
          </div>
          <div className="flex gap-2">
            <span className="px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium cursor-pointer">热度榜</span>
            <span className="px-4 py-1.5 rounded-full bg-background-200 text-foreground-600 text-xs font-medium cursor-pointer hover:bg-background-300 transition-colors">新片榜</span>
            <span className="px-4 py-1.5 rounded-full bg-background-200 text-foreground-600 text-xs font-medium cursor-pointer hover:bg-background-300 transition-colors">口碑榜</span>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                {item.rank <= 3 ? (
                  <span className={`text-lg font-bold font-heading ${
                    item.rank === 1 ? 'text-primary-500' : item.rank === 2 ? 'text-accent-500' : 'text-secondary-500'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                    item.tag === '年度剧王' || item.tag === '科幻巨制'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热门综艺' || item.tag === '热播中' || item.tag === '新一季'
                      ? 'bg-accent-100 text-accent-800'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-400">{item.category}</span>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                <span className="text-sm font-semibold text-primary-500">{item.heat}</span>
                <i className={`text-sm ${
                  item.trend === 'up'
                    ? 'ri-arrow-up-line text-green-500'
                    : item.trend === 'down'
                    ? 'ri-arrow-down-line text-red-400'
                    : 'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}